import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import { isEditorBuild } from "./lib/editorMode";
import App from "./App";
import "./styles/globals.css";

const EditorAuthGate = isEditorBuild
  ? lazy(() => import("./components/editor/EditorAuthGate"))
  : null;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD || import.meta.env.VITE_SENTRY_DEBUG === "true",
  debug: import.meta.env.VITE_SENTRY_DEBUG === "true",
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.2,
});

const AppTree = EditorAuthGate
  ? (
    <Suspense fallback={null}>
      <EditorAuthGate>
        <App />
      </EditorAuthGate>
    </Suspense>
  )
  : <App />;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        {AppTree}
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
